import { reactive } from 'vue'
import { listAiAgents, listAiSuggestions, listKnowledge } from '@/services/wootdashAi'
import { listAiFaqs } from '@/services/wootdashAiFaq'

/**
 * Contadores do grupo "Inteligência Artificial" do menu lateral: agentes e documentos; sugestões a revisar e dúvidas
 * sem resposta (30 dias, como a tela) aparecem em destaque. Estado de módulo: o menu mostra, a tela de IA recarrega
 * depois de salvar/excluir.
 */
export type AiMenuCountKey = 'agents' | 'documents' | 'suggestions' | 'faq'

export const aiMenuCounts = reactive<Record<AiMenuCountKey, number | null>>({
  agents: null, documents: null, suggestions: null, faq: null,
})

export async function loadAiMenuCounts(token: string, withFaq: boolean): Promise<void> {
  const [agents, documents, suggestions, faqs] = await Promise.all([
    listAiAgents(token), listKnowledge(token), listAiSuggestions(token, 'suggested', null, false),
    withFaq ? listAiFaqs(token, 30, 'open', null, '') : Promise.resolve(null),
  ])
  aiMenuCounts.agents = agents.problem ? null : agents.items.length
  aiMenuCounts.documents = documents.problem ? null : documents.items.length
  aiMenuCounts.suggestions = suggestions.data?.counts.suggested ?? null
  aiMenuCounts.faq = faqs?.data?.counts.open ?? null
}
